import React from "react";
import { Button } from "react-bootstrap";
import Icon from "@mdi/react";
import { mdiInformationOutline, mdiOpenInNew } from "@mdi/js";
import DeleteConfirmationModal, {
  deleteJobLabel,
} from "app/containers/JobCalendar/components/DeleteConfirmationModal";
import { CONTACT_MORPH_HREF } from "app/constants/global-constants";
import { deleteJobModalVariant } from "app/containers/Jobs/utils/deleteJobModalCopy";
import "./deleteJobModal.css";

// Refund needs `canRefundInStripe`: the backend also warns about a manual
// payment, which Stripe never charged.
const stripeLinkFor = (key, onOpenStripe, canRefundInStripe) => {
  if (!onOpenStripe) return null;
  if (key === "active_dispute") return "View Dispute";
  if (key === "unrefunded_payment" && canRefundInStripe) return "Refund";
  return null;
};

const warningView = ({ warnings }, props) => ({
  banner: warnings.map(({ key, message }) => {
    const linkLabel = stripeLinkFor(
      key,
      props.onOpenStripe,
      props.canRefundInStripe
    );
    return (
      <div key={key} className="delete-modal-warning">
        <Icon path={mdiInformationOutline} size={0.7} />
        <span className="delete-modal-warning-message">{message}</span>
        {linkLabel && (
          <Button
            variant="link"
            className="delete-modal-warning-link"
            onClick={() => props.onOpenStripe(key)}
          >
            {linkLabel}
            <Icon path={mdiOpenInNew} size={0.6} />
          </Button>
        )}
      </div>
    );
  }),
  note: (
    <p className="delete-modal-note">
      Contract and payment records won&apos;t be deleted. If you need these
      records removed, please <a href={CONTACT_MORPH_HREF}>contact Morph</a>.
    </p>
  ),
  footer: (
    <>
      <Button
        variant="outline-danger"
        onClick={props.onConfirm}
        disabled={props.loading}
      >
        {deleteJobLabel(props.loading)}
      </Button>
      <Button variant="primary" onClick={props.onHide} disabled={props.loading}>
        Keep Job
      </Button>
    </>
  ),
});

// Without a warning, Delete waits for the preview so it can't skip one.
const VIEWS = {
  warning: warningView,
  autoCancel: ({ note }, { previewLoading }) => ({
    note: <p className="delete-modal-note">{note}</p>,
    confirmDisabled: previewLoading,
  }),
  default: (_, { previewLoading }) => ({ confirmDisabled: previewLoading }),
};

const DeleteJobModal = ({
  show,
  onHide,
  onConfirm,
  loading = false,
  preview = null,
  previewLoading = false,
  onOpenStripe = null,
  canRefundInStripe = false,
}) => {
  const variant = deleteJobModalVariant(preview);
  const view = VIEWS[variant.kind](variant, {
    onHide,
    onConfirm,
    loading,
    previewLoading,
    onOpenStripe,
    canRefundInStripe,
  });

  return (
    <DeleteConfirmationModal
      show={show}
      onHide={onHide}
      onConfirm={onConfirm}
      loading={loading}
      {...view}
    />
  );
};

export default DeleteJobModal;
